import $ from "jquery";

const Accordion = () => {
  if (document.getElementsByClassName("accordion").length > 0) {
    const anchorContainer = document.querySelectorAll(".toggle-accordion");

    const toggleAccordion = () => {
      const anchorList = [].slice.call(anchorContainer);
      anchorList.forEach(el => {
        const transcript = $(el).next();
        const accordionEvent = () => {
          if (!$(el).hasClass("open")) {
            $(el).addClass("open");
            $(el).removeClass("closed");
            transcript.attr("aria-hidden", "false");
            $(el)
              .parent()
              .removeClass("accordion-closed");
            $(el)
              .parent()
              .addClass("accordion-active");
            $(el).attr("aria-expanded", "true");
            // Update height of accordion-active element
            transcript
              .parent()
              .height(transcript.height() + 30 + $(el).height() + 6);
            // Update height of accordion element
            transcript
              .parent()
              .parent()
              .height(transcript.height() + 30 + $(el).height() + 12);
          } else {
            $(el).addClass("closed");
            $(el).removeClass("open");
            transcript.attr("aria-hidden", "true");
            $(el)
              .parent()
              .removeClass("accordion-active");
            $(el)
              .parent()
              .addClass("accordion-closed");
            $(el).attr("aria-expanded", "false");

            // Update the height of parent accordion to match the content title height
            $(el)
              .parent()
              .parent()
              .height($(el).height() + 30);
          }
        };

        el.addEventListener("click", () => {
          accordionEvent();
        });

        el.addEventListener("keyup", e => {
          if (e.keyCode === 13 || (e.keyCode === 32 && $(el).is(":focus"))) {
            accordionEvent();
          }
        });
      });
    };

    const initAccordionHeight = () => {
      anchorContainer.forEach(el => {
        const accordion = $(el).parent();
        if (accordion.hasClass("accordion-closed")) {
          accordion.height($(el).height() + 30);
        }
      });
    };

    const init = () => {
      initAccordionHeight();
      toggleAccordion();
    };

    init();
  }
};

export default Accordion;
